import React, { useEffect, useState } from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { PHYSICIAN_ENGAGEMENT_SEGEMENT_CHART_OPTIONS } from './constants';
import { useSelector } from 'react-redux';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { capitalizeFirstLetter } from '../../../../utility';

function EngagementSegments() {
    const { isLoading, physicianEngagementSegmentsDonutChartData } =
        useSelector((state) => state.digitalEngagement);
    const { company } = useSelector((state) => state.company);
    const extraData = true;

    const titles = {
        97: 'Engagement Segments',
        default: 'Physician Engagement Segments',
    };

    const title = titles[company.id] || titles['default'];
    const prepareData = () =>
        physicianEngagementSegmentsDonutChartData.map((item) => {
            // If extraData is true, preserve all fields
            if (extraData) return item;

            // Else return only name and y
            return {
                name: item.name,
                y: item.y,
            };
        });
    const [updatedChartOptions, setUpdatedChartOptions] = useState({
        ...PHYSICIAN_ENGAGEMENT_SEGEMENT_CHART_OPTIONS,
        series: [
            {
                name: null,
                data: prepareData(),
                size: '100%',
                innerSize: '50%',
                showInLegend: true,
                borderRadius: 0,
            },
        ],
    });

    useEffect(() => {
        const isSpecialCompany = company.id === 67;

        setUpdatedChartOptions({
            ...PHYSICIAN_ENGAGEMENT_SEGEMENT_CHART_OPTIONS,
            tooltip: {
                formatter: function () {
                    if (isSpecialCompany)
                        return `<p>${capitalizeFirstLetter(this?.point?.name || '')}</p>: ${this.y.toFixed(2)}%<br/>
                        Engaged: ${this.point.engaged}<br/>
                        Non-Engaged: ${this.point.non_engaged}`;
                    return `${capitalizeFirstLetter(this?.point?.name || '')}: ${this.y.toFixed(2)}%`;
                },
            },
            legend: {
                layout: 'vertical',
                align: 'center',
                verticalAlign: 'bottom',
                labelFormatter: function () {
                    if (isSpecialCompany) {
                        return `${capitalizeFirstLetter(this?.name || '')}: ${this.y.toFixed(2)}%  (${this.engaged}/${this.non_engaged})`;
                    }
                    return `${capitalizeFirstLetter(this?.name || '')}: ${this.y.toFixed(2)}%`;
                },
                itemStyle: { fontWeight: 'normal' },
            },
            series:
                physicianEngagementSegmentsDonutChartData.length > 0
                    ? [
                          {
                              name: null,
                              data: prepareData(),
                              size: '100%',
                              innerSize: '50%',
                              showInLegend: true,
                              borderRadius: 0,
                          },
                      ]
                    : [],
        });
    }, [physicianEngagementSegmentsDonutChartData, company.id]);

    return (
        <Box className="container-p-24-br-16 bg-gray-50">
            <Box>
                <Typography className="text-md-medium gray-900">
                    {title}
                </Typography>
            </Box>
            {/* HighChartDonutChart */}
            {isLoading ? (
                <Skeleton height={400} variant="rectangular" width="100%" />
            ) : (
                <HighchartsReact
                    highcharts={Highcharts}
                    options={updatedChartOptions}
                />
            )}
        </Box>
    );
}

export default EngagementSegments;
